import React from 'react'
import {
  Form, FormGroup,
  Label, Card, CardBody,
} from 'reactstrap'
import ReactSelect from 'react-select'
import _ from 'lodash'

import Lang from 'Lang/General'

const Newsletters = ({
  currentForm,
  formType,
  onChangeFormsHOC,
  selectedLanguage,
  newsletterRecipientGroups
}) => {
  return(
    <Form>
      <Card className='mb-3' >
        <CardBody>
          <FormGroup>
            <Label>{ Lang[ 'WHEN_FORM_SUBMITTED_ADD_USER_TO_FOLLOWING_RECIPIENT_GROUPS' ][ selectedLanguage ] }</Label>
            <ReactSelect
              isMulti
              value={ currentForm.recipient_group_ids }
              options={ newsletterRecipientGroups }
              onChange={ values => {
                let tmpForm = _.cloneDeep( currentForm )
                tmpForm.recipient_group_ids = values
                return onChangeFormsHOC( formType, tmpForm )
              }}
            />
          </FormGroup>
        </CardBody>
      </Card>
    </Form>
  )
}

export default Newsletters
